import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import registerPatient from "api/registerPatient";
import { usePatientsContext } from "context/patient_context";
import { PRODUCTION_MODE } from "../helpers/Functions";
import { detectPathUrl } from "../helpers/detectPathUrl";
import useAgentInfo from "./useAgentInfo";

const useRegisterPatient = () => {
  const { handleOpenErr } = usePatientsContext();
  const navigate = useNavigate();
  const { data: agentInfo } = useAgentInfo();

  const mutateReminder = useMutation({
    mutationFn: registerPatient,
    onSuccess: ({ res }, args) => {
      const { setSuccessfullySend, setPatientId, setOpen } = args;
      if (res.status === 200)
        setSuccessfullySend(true);
      setPatientId(res?.data?.id);
      if (agentInfo?.isScanCenter) {
        navigate(detectPathUrl(`app/report?patientId=${res?.data?.id}`), { replace: true });
      } else setOpen(true);
    },
    onError: (error, args) => {
      const { setSuccessfullySend } = args;
      setSuccessfullySend(false);
      handleOpenErr(error.response.data.messages);
    }
  });
  return mutateReminder;
};

export default useRegisterPatient;